import React from 'react';
import type { PrivatePortfolioNode } from 'venn-api';
import type { SearchMenuItem } from 'venn-components';
import { noop } from 'lodash';

interface FieldType<T> {
  value: T;
  error: string;
  isLoading: boolean;
}

export type ContextIdState =
  | {
      hasNewPermissions: false;
    }
  | {
      hasNewPermissions: true;
      ownerContextId: string | null;
      setOwnerContextId: React.Dispatch<React.SetStateAction<string | null>>;
    };

export type ValidationState =
  | {
      isValid: true;
    }
  | {
      isValid: false;
      error: string;
    };

export type CreatePrivatePortfolioContext = {
  name: FieldType<string>;
  setName: React.Dispatch<React.SetStateAction<CreatePrivatePortfolioContext['name']>>;
  sourcePortfolio: FieldType<SearchMenuItem | null>;
  setSourcePortfolio: React.Dispatch<React.SetStateAction<CreatePrivatePortfolioContext['sourcePortfolio']>>;
  createPortfolio: (investments: PrivatePortfolioNode[]) => Promise<PrivatePortfolioNode>;
  isSubmitting: boolean;
} & ContextIdState &
  ValidationState;

// TODO(VENN-24534): add a display name to this React component
// eslint-disable-next-line react/display-name
const context = React.createContext<CreatePrivatePortfolioContext>({
  name: {
    value: '',
    error: '',
    isLoading: false,
  },
  setName: noop,
  sourcePortfolio: {
    value: null,
    error: '',
    isLoading: false,
  },
  hasNewPermissions: false,
  setSourcePortfolio: noop,
  createPortfolio: (_) => Promise.reject(),
  isSubmitting: false,
  isValid: true,
});

export const { Provider, Consumer } = context;
export default context;
